import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import * as R from 'ramda';
import React, { useEffect, useRef, useState, useCallback } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { removerBreadcrumb2 } from "../breadcrumb2/breadcrumb2Utils";
import { removerComponenteReact } from "../renderizarOuRemoverComponentReact";
import { DadosFichaCrediario, FichaCrediario } from "./FichaCrediarioCliente";

export type FichaCrediarioContainerProps = {
  codigoCliente?: number;
  cliente?: any;
  somenteLeitura?: boolean; // 430731
  onVoltar?: () => void;
  passos?: Dict<string, () => void>;
  onRemover?: () => boolean;
};

export const FichaCrediarioContainer = (props: FichaCrediarioContainerProps) => {
  const orcamento = useAppSelector((store) => store.orcamento);
  // const [dadosFormulario, setDadosFormulario] = useState<Array<{
  //   CodigoDadoAdicional: number;
  //   Descricao: string;
  //   Tipo: string;
  //   Valor: string;
  //   UserMessage?: string | null;
  // }>>([]);
  const [dadosFormulario, setDadosFormulario] = useState<Array<DadosFichaCrediario>>([]);
  const [mostrarFicha, setMostrarFicha] = useState(false);
  const [processando, setProcessando] = useState(false);

  const passosInterno = useRef<Dict<string, () => void>>(
    props.passos ? new Dict(Object.assign({}, props.passos.map)) : new Dict()
  );

  // Otimização: useCallback para funções chamadas em efeitos
  const buscarDadosFichaCrediario = useCallback(async () => {
    try {
      if (!props.codigoCliente) return;
      
      globalMU.blockUI();
      const dadosFichaCrediario = await microuniversoApi.Cliente.BuscarFichaCrediario(props.codigoCliente);
      setDadosFormulario(dadosFichaCrediario);
      setMostrarFicha(true);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, [props.codigoCliente]);

  // Otimização: useCallback para função de salvar
  const salvarDados = useCallback(async (dadosFormulario: any, codigosAlterados: number[]) => {
    try {
      if (!props.codigoCliente) return;
      
      setProcessando(true);
      globalMU.blockUI();

      const filterCodigosAlterados = (valor: [string, any]) => 
        R.includes(parseInt(valor[0], 10), codigosAlterados);

      const dadosFiltrados = R.filter(filterCodigosAlterados, R.toPairs(dadosFormulario));

      const resultado = await microuniversoApi.Cliente.SalvarFichaCrediario(
        props.codigoCliente, 
        dadosFiltrados
      );
      
      if (resultado) {
        globalMU.showSuccessMessage('Ficha de Crediário salva com sucesso!');
        // Atualiza os dados após salvar
        setDadosFormulario([])
        buscarDadosFichaCrediario();
      }
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      setProcessando(false);
      globalMU.unblockUI();
    }
  }, [props.codigoCliente, buscarDadosFichaCrediario]);

  // Função para lidar com passos selecionados
  const onPassoSelecionado = useCallback((passo: string) => {
    if (props.passos) {
      props.onRemover?.();
      passosInterno.current.get(passo)?.();
    } else {
      if (passo === "Cadastro Cliente") {
        removerComponenteReact("ficha-crediario-container");
        $("#form-cadastro-cliente").show();
        removerBreadcrumb2();
      }
    }
  }, [props.passos, props.onRemover]);

  // Função para voltar
  const onVoltar = useCallback(() => {
    if (props.passos) {
      props.onRemover?.();
      props.onVoltar?.();
    } else {
      removerComponenteReact("ficha-crediario-container");
      $("#form-cadastro-cliente").show();
      removerBreadcrumb2();
    }
  }, [props.passos, props.onRemover, props.onVoltar]);

  // Efeito para inicialização
  useEffect(() => {
    if (props.passos) {
      passosInterno.current.set("Ficha de Crediário", () => {});
    }
    buscarDadosFichaCrediario();
  }, [buscarDadosFichaCrediario, props.passos]);

  return (
    <div data-testid="ficha-crediario-container">
      <Breadcrumb2Container
        passos={props.passos ? passosInterno.current.keysToList() : ["Cadastro Cliente", "Ficha de Crediário"]}
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        onPassoSelecionado={onPassoSelecionado}
        onBotaoVoltarClicado={onVoltar}
        data-testid="breadcrumb-container"
        id="ficha-crediario-breadcrumb"
      />

      {mostrarFicha && (
        <FichaCrediario
          cpfCnpj={props.cliente ? props.cliente.attributes.CpfCnpj : orcamento.Cliente.CpfCnpj}
          nome={props.cliente ? props.cliente.attributes.Nome : orcamento.Cliente.Nome}
          onSalvar={salvarDados}
          dadosFichaCrediario={dadosFormulario}
          somenteLeitura={props.somenteLeitura}
          processando={processando}
          data-testid="ficha-crediario-component"
        />
      )}
    </div>
  );
};